/**
 * @generated SignedSource<<199e333eec6c65901c55c99ec3e1e9d5>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "_id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "careOrderIdList"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
    }, v2 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "_id",
                    "variableName": "_id"
                },
                {
                    "kind": "Variable",
                    "name": "careOrderIdList",
                    "variableName": "careOrderIdList"
                }
            ],
            "concreteType": "ClientCareOrder",
            "kind": "LinkedField",
            "name": "clientCareOrderList",
            "plural": true,
            "selections": [
                (v1 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "certificateId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientPayment",
                    "kind": "LinkedField",
                    "name": "paymentList",
                    "plural": true,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalFee",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancellationFee",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paid",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "graphqlClientUnpaidCareOrderListQuery",
            "selections": (v2 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "graphqlClientUnpaidCareOrderListQuery",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "cacheID": "3926399a9dc62894ca2514377348958e",
            "id": null,
            "metadata": {},
            "name": "graphqlClientUnpaidCareOrderListQuery",
            "operationKind": "query",
            "text": "query graphqlClientUnpaidCareOrderListQuery(\n  $_id: String!\n  $careOrderIdList: [String]\n) {\n  clientCareOrderList(_id: $_id, careOrderIdList: $careOrderIdList) {\n    _id\n    certificateId\n    paymentList {\n      _id\n      totalFee\n      cancellationFee\n      paid\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "dca7336eaccb365cd8dc84839e334e62";
export default node;
